import { forEachWithGitYield } from '../../git-runtime.js';
import { unifiedDiffForFileInRange } from '../patch/unified-diff-for-file.js';
import { resolveCommitFileTotalLines } from '../total-lines/resolve-changed-file-total-lines.js';
import type { WorkingTreeChangeFileRow } from '../types.js';
import { filePathRelativeToRepoRootFromWorkspace } from './file-path-relative-to-repo-root-from-workspace.js';

export async function enrichCommitFileRows(options: {
  rows: WorkingTreeChangeFileRow[];
  repoGitCwd: string;
  repoPathRelativeToWorkspaceRoot: string;
  range: string;
  commitSha: string;
  parentSha: string;
  binaryByPath: Set<string>;
}): Promise<void> {
  await forEachWithGitYield(options.rows, async (row) => {
    const filePathRelativeToRepoRoot = filePathRelativeToRepoRootFromWorkspace(
      row.workspaceRelPath,
      options.repoPathRelativeToWorkspaceRoot,
    );
    row.patchContent = await unifiedDiffForFileInRange(
      options.repoGitCwd,
      options.range,
      filePathRelativeToRepoRoot,
      row.change,
      row.movedFromPathInRepo,
    );
    row.totalLines = await resolveCommitFileTotalLines({
      repoGitCwd: options.repoGitCwd,
      pathInRepo: filePathRelativeToRepoRoot,
      change: row.change,
      commitSha: options.commitSha,
      parentSha: options.parentSha,
      isBinary: options.binaryByPath.has(filePathRelativeToRepoRoot),
    });
  });
}
